import { Component, computed, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ProjectSettingFormComponent } from '@shared/components/project-setting-form/project-setting-form.component';

@Component({
    selector: 'app-configure-sidemark-pricing',
    templateUrl: './configure-sidemark-pricing.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatButton,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
        MatDialogActions,
        ProjectSettingFormComponent,
    ],
})
export class ConfigureSidemarkPricingComponent {
    private readonly dialogRef = inject(MatDialogRef<ConfigureSidemarkPricingComponent>);
    private readonly projectSettingFormComponent = viewChild(ProjectSettingFormComponent);

    readonly saveDisabled = computed(() => {
        const formComponent = this.projectSettingFormComponent();
        return !formComponent || formComponent.isLoading() || formComponent.isFormInvalid();
    });

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    save(): void {
        const formComponent = this.projectSettingFormComponent();
        if (!formComponent) return;

        if (formComponent.isFormInvalid()) {
            formComponent.projectSettingForm?.markAllAsTouched();
            return;
        }

        this.dialogRef.close(formComponent.buildSidemarkPricingConfig());
    }
}
